import { render, staticRenderFns } from "./CobroPage.vue?vue&type=template&id=259440be&"
import script from "./CobroPage.vue?vue&type=script&lang=js&"
export * from "./CobroPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports